import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const filtersSelector = createSelector(selfSelector, (analytic) => analytic.filter);

export default filtersSelector;
